import React, { forwardRef } from 'react'
import RadioGroup from 'modules/ui/atoms/RadioGroup'

import { useFormContext, useController } from 'react-hook-form'
import useConfig from 'modules/config/state/use-config'

type RadioGroupOption = {
  key: string
  label: string
}

export type RadioGroupFieldProps = {
  id: number | string
  label: string
  options: RadioGroupOption[]
  error?: { message: string }
  required?: boolean
  dataId?: string
  autoFocus?: boolean
  onFocus?: () => void
}

const RadioGroupField = forwardRef<HTMLDivElement, RadioGroupFieldProps>(
  ({ id, label, options, error, required, dataId = '', autoFocus, onFocus }, ref) => {
    const { control } = useFormContext()
    const config = useConfig()

    const { field } = useController({
      name: `${id}`,
      control,
    })

    return (
      <div>
        <RadioGroup
          label={label}
          options={options}
          {...field}
          name={label}
          id={`${id}`}
          error={error?.message}
          required={required}
          dataId={dataId}
          ref={ref}
          autoFocus={autoFocus}
          isEmbedded={config.isEmbedded}
          onFocus={onFocus}
        />
      </div>
    )
  },
)

RadioGroupField.displayName = 'RadioGroupField'

export default RadioGroupField
